export default __webpack_public_path__ + "static/screen_ipad_pins-375d8e807d8c6df92b99d0cc267a0b47.png";